module.exports = __webpack_public_path__ + "static/media/rooster_logo_small.57ccfc34.png";